<template>
  <div>
    <ValidationObserver>
      <select-input
        v-model="type"
        name="contact[inquiry_type]"
        :required="true"
        :inputStyle="{ backgroundColor: '#FBF9F5' }"
        :label="topicLabel"
        containerClass="old-mb-4"
      >
        <option disabled selected value>{{ topicLabel }}</option>
        <option
          v-for="option in topicOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select-input>

      <ValidationProvider
        name="name"
        rules="required|alpha_spaces"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="fullName"
          type="text"
          name="contact[name]"
          :required="true"
          :inputStyle="{ backgroundColor: '#FBF9F5' }"
          :label="nameLabel"
          containerClass="old-mb-4"
          :error="errors && errors[0]"
        />
      </ValidationProvider>

      <ValidationProvider
        name="email"
        rules="required|email"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="email"
          type="text"
          name="contact[email]"
          :required="true"
          :inputStyle="{ backgroundColor: '#FBF9F5' }"
          :label="emailLabel"
          containerClass="old-mb-1"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
      <p class="old-mb-4 fs-14 sm--fs-12">{{ emailHint }}</p>

      <ValidationProvider
        name="email confirmation"
        rules="required|confirm-nocase:@email"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="confirmEmail"
          type="text"
          name="contact[confirm_email]"
          :required="true"
          :inputStyle="{ backgroundColor: '#FBF9F5' }"
          :label="confirmEmailLabel"
          containerClass="old-mb-4"
          :error="errors && errors[0]"
        />
      </ValidationProvider>

      <ValidationProvider
        name="order number"
        rules="alpha_num"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="orderNumber"
          type="text"
          name="contact[order_number]"
          :inputStyle="{ backgroundColor: '#FBF9F5' }"
          :label="orderNumberLabel"
          containerClass="old-mb-1"
          :error="errors && errors[0]"
        />
      </ValidationProvider>
      <p class="old-mb-4 fs-14 sm--fs-12">{{ orderNumberHint }}</p>

      <ValidationProvider
        name="body"
        rules="required"
        v-slot="{ errors }"
        mode="eager"
        slim
      >
        <text-input
          v-model="body"
          type="textarea"
          :maxlength="500"
          name="contact[body]"
          :required="true"
          :inputStyle="{ backgroundColor: '#FBF9F5', minHeight: '190px' }"
          :label="bodyLabel"
          containerClass="old-mb-4"
          :error="errors && errors[0]"
        />
      </ValidationProvider>

      <p class="mb-4 font-calibre text-xs" v-html="disclaimerHtml"></p>

      <button type="submit" class="button-link caps">
        {{ submitLabel }}
      </button>
    </ValidationObserver>
  </div>
</template>

<script>
import { handleize } from "@/lib/utils";

export default {
  name: "contact-form",
  props: {
    topics: Array,
    topicLabel: String,
    nameLabel: String,
    emailLabel: String,
    emailHint: String,
    confirmEmailLabel: String,
    orderNumberLabel: String,
    orderNumberHint: String,
    fileLabel: String,
    bodyLabel: String,
    submitLabel: String,
    disclaimerHtml: String,
  },
  data() {
    return {
      type: "",
      fullName: "",
      email: "",
      confirmEmail: "",
      orderNumber: "",
      body: "",
      file: "",
    };
  },
  computed: {
    topicOptions() {
      return this.topics.map((topicString) => ({
        value: handleize(topicString),
        label: topicString,
      }));
    },
  },
};
</script>
